function RegisterFieldDecorator() {
	
	function attach($scope, params) {
		
	}

	return {
		attach: attach
	}	
}